import Step from "./Step"
import Button from "../../Components/Button"
import { Field } from "formik"
import * as Yup from "yup"
import FormikField from "../../Components/Forms/FormikField"
import ListTextPreview from "../../Components/ListTextPreview"
import { roleAtom, userAtom, planAtom } from "../../state"
import { useAtom } from "jotai"
import { visionOptions } from "../../constants/visionOptions"
import { getStepMetadata } from "../../constants/stepRegistry"
import { PLAN_USER_ROLE } from "../../constants/planUserRole"
import { ENCOURAGEMENT_RESOURCE_URL } from "../../constants/resources"
import { getPlanStudentFirstName } from "../../lib/plan"
import {MoreInfoVideoModal} from "../../Components/MoreInfoVideoModal";
import GoalBlock from "../../Components/GoalBlock"

const stepMetadata = getStepMetadata("encouragement")

const shape = {
  encouragement: Yup.string().required("Required"),
}
const schema = Yup.object().shape(shape)

const step = {
  name: stepMetadata.name,
  title: "Speak life into your student.",
  type: stepMetadata.type,
  instructions: [
    "Share 1-2 encouragements for what your student has shared in their identity, gifts and vision activities. Encouragements don't need to be long - just given in love.",
    "Take a few minutes to reflect and then share with your student.",
    <MoreInfoVideoModal
      src={ENCOURAGEMENT_RESOURCE_URL}
      type={"pdf"}
      postText={"Encouragement Examples"}
      icon={"fa-regular fa-file-pen"}
      text={""}
      title={"Encouragement Examples"}
      textClassName={"text-encouragement no-underline"}
    />,
  ],
  discussionQuestions: [
    "Share how you've seen one of their gifts play out in their daily life.",
    "What do you believe God might be doing in their life right now?",
    "What wisdom related to one of their goals would you like to share?",
  ],
}
function Encouragement() {
  const [user] = useAtom(userAtom)
  const [role] = useAtom(roleAtom)
  const [plan] = useAtom(planAtom)

  const getPreviewData = (data, filterMentorId = null) => {
    if (filterMentorId) {
      return data.encouragements.filter(item => item.user_id === filterMentorId)
    }
    return data.encouragements
  }
  const getIsComplete = data => {
    if (role == PLAN_USER_ROLE.YOUTH || role == PLAN_USER_ROLE.GUIDE) {
      return data.encouragements.length > 0
    }
    return data.encouragements.filter(item => item.user_id == user.id).length > 0
  }
  const onSubmit = (values, actions, onSubmit) => {
    onSubmit({ encouragements: [values.encouragement] }, false, false)
    actions.resetForm()
  }

  return (
    <Step
      step={step}
      Preview={ListTextPreview}
      getIsComplete={getIsComplete}
      getPreviewData={getPreviewData}
      keys={[
        "encouragements",
        "visions",
        "other_title",
        "faith_vision",
        "family_vision",
        "sports_vision",
        "school_vision",
        "arts_music_vision",
        "travel_vision",
        "hobbies_vision",
        "service_vision",
        "other_vision",
        "relationships_vision",
        "work_vision",
        "justice_vision",
      ]}
      schema={schema}
      onSubmit={onSubmit}
      image={stepMetadata.image}
      theme={stepMetadata.theme}
      description={stepMetadata.description}
    >
      {(values, data) => (
        <>
          <FormikField
            primary={true}
            name="encouragement"
            instructions={step.instructions}
            title={step.title}
          >
            <div className="mb-4">
              <h3 className="mb-2 text-lg font-bold">Reflection Prompts</h3>
              <p className="mb-2">Use these questions to shape your encouragement.</p>
              <ul className="mb-4 list-inside list-disc">
                {step.discussionQuestions.map((question, index) => (
                  <li className={"font-bold"} key={index}>
                    {question}
                  </li>
                ))}
              </ul>
            </div>

            <GoalBlock data={data} plan={plan} />

            <>
              <div className="mb-4 text-sm">Write 1 or 2 encouragements below.</div>
              <ListTextPreview
                data={getPreviewData(data)}
                editable={true}
                theme="encouragement"
                heading="Mentor Encouragements"
              />

              <div className="mb-2 mt-4 flex items-center gap-4">
                <Field
                  as="textarea"
                  key={data.encouragements.length + 1}
                  name="encouragement"
                  placeholder="You are..."
                  className="h-32 w-full rounded-md border p-2"
                />
              </div>
              <Button bgColor="bg-encouragement hover:bg-encouragement/90 mb-8" type="submit">
                Add Encouragement
              </Button>
            </>
          </FormikField>
        </>
      )}
    </Step>
  )
}

export default Encouragement
